<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block">History</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <ng-container>
        <div style="padding: 16px 24px 16px 24px;">
            <div class="col-12" style="width: 100%;">
                <div class="body">
                    <div class="part-1">
                        <div class="part-3">
                            <label class="catlabel ">Invoice Number :</label>
                            <label class="text ">{{invoiceNum}}</label>
                        </div>
                        <div class="part-3">
                            <label class="catlabel ">Supplier :</label>
                            <label class="text ">{{supplier}}</label>
                        </div>
                    </div>
                    <div class="part-1">
                        <div class="part-3">
                            <label class="catlabel">PO :</label>
                            <label class="text">{{po}}</label>
                        </div>
                        <div class="part-3">
                            <label class="catlabel">PO Line :</label>
                            <label class="text">{{poLine}}</label>
                        </div>
                        <div class="part-3">
                            <label class="catlabel">Back Number :</label>
                            <label class="text">{{backNum}}</label>
                        </div>
                    </div>
                    <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
                    <ag-grid-angular [enableCellTextSelection]="true" style="width:100%;height:466px;" id="LIOS-GRID-SMALL" class="ag-theme-balham"
                        (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true"
                        [getRowHeight]="getRowHeight" [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="rowData"
                        [context]="context" [icons]="icons">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </ng-container>
</div>